ACC.order = {

    _autoload: [
        "backToOrderHistory",
        "bindMultidProduct",
        "scrollToConditions",
        "init"
    ],

    backToOrderHistory: function(){
        $(".orderBackBtn > button").on("click", function(){
            var sUrl = $(this).data("backToOrders");
            window.location = sUrl;
        });
    },

    bindMultidProduct: function ()
    {
        // link to display the multi-d grid in read-only mode
        $(document).on("click",'.js-show-multiD-grid-in-order', function (event){
            ACC.multidgrid.populateAndShowGrid(this, event, true);
            return false;
        });

        // link to display the multi-d grid in read-only mode
        $(document).on("click",'.showMultiDGridInOrderOverlay', function (event){
            ACC.multidgrid.populateAndShowGridOverlay(this, event);
        });

    },

    scrollToConditions: function()
    {
        $(".terms_enlevement").click(function(e) {
            e.preventDefault();
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#enlevementConditions").offset().top - 100
            }, 700);
        });
    },
    init: function () {
        const svg = '<svg viewBox="0 0 33 14" xmlns="http://www.w3.org/2000/svg" aria-labelledby="Long Arrow" role="presentation" class="svg-icon"><polygon points="25.1604773 0 32.6352213 6.85610681 25.1993812 13.7359725 24.3690601 12.8391022 30.1441884 7.49516092 0.0024154589 7.43569437 0 6.21588761 30.2001884 6.27516092 24.3378796 0.897439017" stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd"></polygon></svg>';
        $('#reorderForm button.re-order').each(function(i, el) {
            $(el).html('<span>' + $(el).text() + '</span>').addClass('btn-amds re-order w-100 permanent-disabled normal-btn').append(svg);
        });
    }
};


